import type { BaseEntity } from '../../BaseEntity';
import type { Displays_Owner } from './Displays_Owner';
import type { Displays_Resolution } from './Displays_Resolution';
import type { Displays_FileType } from './Displays_FileType';
import type { Displays_Screen } from './Displays_Screen';
import type { Displays_Country } from './Displays_Country';
import type { Displays_Market } from './Displays_Market';
import type { Displays_OperationalTime } from './Displays_OperationalTime';

export enum DisplayPackType {
    Pack = 'pack',
    Site = 'site',
}

export type Displays_Pack = BaseEntity & {
    country_id?: number;
    market_id?: number;
    ext_id?: number;
    owner_id?: number;

    pack_type: DisplayPackType;
    resolution: string;
    size: string;
    animation: string;
    slots: number;
    slot_length: string;
    env: string;
    name: string;
    description: string;
    brochurelink: string;
    brochure: string;
    status: number;

    unilive_id?: number;

    // include
    market?: Displays_Market;

    // include
    owner?: Displays_Owner;

    // include
    resolutions?: Displays_Resolution[];

    // include
    filetypes?: Displays_FileType[];

    // include
    country?: Displays_Country;

    // include
    activeDisplays?: Displays_Screen[];

    // include
    activeDisplaysCount?: number;

    // include
    inactiveDisplays?: Displays_Screen[];

    // include
    inactiveDisplaysCount?: number;

    operationalTimes?: Displays_OperationalTime[];
};
